import React from "react";
import Link from "next/link";
import Icon from "./Icon";
import { Trans } from "@lingui/react/macro";

const styles = `
.t26-pagehead {
  padding: clamp(40px, 6vw, 80px) clamp(16px, 4vw, 32px) clamp(20px, 3vw, 32px);
  max-width: var(--container);
  margin-inline: auto;
  text-align: center;
}
.t26-pagehead__crumbs {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 12px; font-weight: 600;
  letter-spacing: .12em; text-transform: uppercase;
  color: var(--ink-3);
  margin-bottom: 14px;
}
.theme-2026--embed .t26-pagehead__crumbs {
  display: none;
}
.t26-pagehead__crumbs a {
  color: inherit;
  text-decoration: none;
  transition: color .15s ease;
}
.t26-pagehead__crumbs a:hover { color: var(--primary); }
.t26-pagehead__title {
  font-family: var(--font-display);
  margin: 0;
  font-size: clamp(28px, 4.4vw, 52px);
  font-weight: 700;
  letter-spacing: -.02em;
  color: var(--ink);
  text-wrap: balance;
}
.t26-pagehead__title em {
  font-style: italic;
  color: color-mix(in oklab, var(--primary) 70%, var(--secondary) 30%);
}
.t26-pagehead__sub {
  margin: 12px 0 0;
  font-size: 16px;
  color: var(--ink-3);
  max-width: 60ch;
  margin-inline: auto;
  text-wrap: pretty;
}
`;

export default function PageHeader({ title, titleEm, subtitle, crumbs }) {
    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: styles }} />
            <header className="t26-pagehead">
                {crumbs && crumbs.length > 0 && (
                    <div className="t26-pagehead__crumbs">
                        {crumbs.map((c, i) => (
                            <React.Fragment key={i}>
                                {i > 0 && <Icon name="chevronRight" size={11} className="t26-flip-rtl" />}
                                {c.url ? <Link href={c.url} legacyBehavior><a>{c.label}</a></Link> : <span>{c.label}</span>}
                            </React.Fragment>
                        ))}
                    </div>
                )}
                <h1 className="t26-pagehead__title">
                    {title}
                    {titleEm && <> <em>{titleEm}</em></>}
                </h1>
                {subtitle && <p className="t26-pagehead__sub">{subtitle}</p>}
            </header>
        </>
    );
}
